/*
 * Copyright 2021 LABOR.digital
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Last modified: 2021.06.30 at 10:53
 */
import { forEach, isFunction } from '@labor-digital/helferlein';
import { makeGetterProvider } from '../util';
var DiContainer = /** @class */ (function () {
    function DiContainer(config) {
        var _this = this;
        this._factories = {};
        this._instances = {};
        this._reactiveGetters = makeGetterProvider(this, function (key) { return _this.get(key); });
        forEach(config, function (v, k) { return _this.setFactory(k, v); });
    }
    /**
     * Sets the service instance with a certain key
     * @param key The key of the instance to register
     * @param instance The service instance to register
     */
    DiContainer.prototype.set = function (key, instance) {
        this._instances[key] = instance;
        this._reactiveGetters.add(key);
        return this;
    };
    /**
     * Registers a new factory to create a service with.
     * NOTE: If the service was already instantiated this does nothing.
     *
     * @param key The key of the instance to register the factory for
     * @param factory The function to create a new instance of the service registered for the given key
     */
    DiContainer.prototype.setFactory = function (key, factory) {
        if (!isFunction(factory)) {
            throw new Error('Invalid factory provided for service with key: "' + key + '"');
        }
        this._factories[key] = factory;
        this._reactiveGetters.add(key);
        return this;
    };
    /**
     * Returns the instance of a specific service which was configured
     * @param key
     */
    DiContainer.prototype.get = function (key) {
        if (this._instances[key]) {
            return this._instances[key];
        }
        if (!this._factories[key]) {
            return undefined;
        }
        var i = this._factories[key](this);
        this._instances[key] = i;
        return i;
    };
    /**
     * Checks if the container can resolve a specified service
     * @param key
     */
    DiContainer.prototype.has = function (key) {
        return !!(this._instances[key] || this._factories[key]);
    };
    return DiContainer;
}());
export { DiContainer };
//# sourceMappingURL=DiContainer.js.map